/**
 * A HOC wrapping Material UIs Paper Component. Used to unify the styles across
 * all of our tables. NOTE: We also use the native Paper component in some
 * situations, but for our tables, use this TablePaper component.
 */
import { isEmpty, omit } from 'lodash';
import React from 'react';
import { withStyles } from 'tss-react/mui';
import { Paper } from '@mui/material';

const styles = (theme, props) => {
  if (isEmpty(theme)) return {};

  return {
    root: {
      backgroundColor: '#f9f9f9',
      borderRadius: '4px',
      display: 'flex',
      flex: '2',
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginTop: props.noMargin ? undefined : '25px',
      overflow: 'auto',
      width: 'auto',
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
      maxHeight: props.height ? 'unset' : props.max_height || '75vh',
      minHeight: props.height ? 'unset' : props.min_height || '30vh',
      height: props.height || 'unset',
    },
  };
};

export default withStyles((props) => {
  const { classes } = props;
  const passedProps = omit(props, ['noMargin']);
  return <Paper className={classes.root} {...passedProps} />;
}, styles);
